import {
  ExportMapControl,
  DispatchProps,
  ParentProps,
  OwnProps,
  mapStateToProps
} from '../../core/components/Export/ExportMapControl'
import {connect} from 'react-redux'
import {appExportMapDispatcher} from '../../dispatchers/appExportMapDispatcher'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'

class AppExportMapControl extends ExportMapControl {}

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appExportMapDispatcher,
  ...appMapDispatcher
})(AppExportMapControl)
